import React, { useState, useEffect } from 'react'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import { isValidUrl } from '@dfb/gatsby-dfb-theme/src/utils/url'

// This package is used, because the regular dangerouslySetInnerHTML does not execute any scripts.
// See https://www.npmjs.com/package/dangerously-set-html-content
import InnerHTML from 'dangerously-set-html-content'

interface MDataCenterProps {
  data: {
    path_segment?: string
    space_before_class?: string
    space_after_class?: string
    background_color?: string
    anchor_name?: string
    add_class?: string
  }
}

const MDataCenter = ({ data }: MDataCenterProps) => {
  const url = process.env.DATACENTER_HOST + data.path_segment
  const [markup, setMarkup] = useState(null)

  useEffect(() => {
    if (isValidUrl(url)) {
      const sanitizedUrl = new URL(url)
      sanitizedUrl.searchParams.set('ssg_embed', 'true')
      fetch(sanitizedUrl)
        .then((response) => response.text())
        .then((html) => {
          // Transform html string and add script with window.upgradeAllBehaviours()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const script = doc.createElement('script')
          script.type = 'module'
          script.text = 'if (window.upgradeAllBehaviours) window.upgradeAllBehaviours()'
          doc.body.appendChild(script)
          const newHtml = doc.documentElement.outerHTML

          // Set the new html string to the state
          setMarkup(newHtml)
        })
        .catch((error) => console.error(error))
    }
  }, [url])

  if (!markup) {
    return null
  }

  return (
    <Section baseClass="m-DataCenter" defaultPaddingTop="small" data={data}>
      <InnerHTML html={markup} allowRerender={true} />
    </Section>
  )
}

export default MDataCenter
